import { createApp } from 'vue'
import App from './App.vue'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import "./assets/main.css"
import router from './router'
//import './assets/tailwind.css'
import i18n from './i18n'
import Vue3TouchEvents from "vue3-touch-events";
import './registerServiceWorker'

createApp(App).use(router).use(i18n).use(Vue3TouchEvents, {
    disableClick: true,
  swipeTolerance: 30, // Opcional
  tapTolerance: 10,    // Opcional
  longTapTimeInterval: 400 // Opcional
}).mount('#app')

